module.exports = __webpack_public_path__ + "img/sticker-0-8.35f27cd4.svg";